"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FavoritesRepositoryApiImpl = void 0;
const yup_1 = require("yup");
const favorites_1 = require("../../services/favorites");
class FavoritesRepositoryApiImpl {
    constructor(favoritesService, listInfo) {
        this.favoritesService = favoritesService;
        this.listInfo = listInfo;
        this.strategyName = 'api';
        this.productSchema = (0, yup_1.object)({
            sku: (0, yup_1.string)().required(),
            organization: (0, yup_1.string)()
                .required()
                .test((value) => {
                try {
                    this.parseOrganizationSlugNameToEnum(value);
                    return true;
                }
                catch (error) {
                    return false;
                }
            }),
        });
    }
    getAllItems() {
        return __awaiter(this, void 0, void 0, function* () {
            const favorites = yield this.favoritesService.getFavorites({
                businessUnit: this.listInfo.businessUnit,
                customerId: this.listInfo.customerId,
                listName: this.listInfo.listName,
                resellerSlug: this.listInfo.resellerSlug,
            });
            return this.mapToProductItemSku(favorites);
        });
    }
    addItems(products) {
        return __awaiter(this, void 0, void 0, function* () {
            const validProducts = products
                .filter((product) => this.productSchema.isValidSync(product))
                .map((product) => ({
                sku: product.sku,
                organization: this.parseOrganizationSlugNameToEnum(product.organization),
            }));
            const hasNoValidProductsToAdd = !validProducts.length;
            if (hasNoValidProductsToAdd) {
                return [];
            }
            const favorites = yield this.favoritesService.addFavorites({
                businessUnit: this.listInfo.businessUnit,
                customerId: this.listInfo.customerId,
                listName: this.listInfo.listName,
                resellerSlug: this.listInfo.resellerSlug,
                products: validProducts,
            });
            return this.mapToProductItemSku(favorites);
        });
    }
    removeItem(product) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.productSchema.isValidSync(product)) {
                throw new Error('Invalid product');
            }
            const favorites = yield this.favoritesService.removeFavorite({
                businessUnit: this.listInfo.businessUnit,
                customerId: this.listInfo.customerId,
                listName: this.listInfo.listName,
                resellerSlug: this.listInfo.resellerSlug,
                productOrganization: this.parseOrganizationSlugNameToEnum(product.organization),
                sku: product.sku,
            });
            return this.mapToProductItemSku(favorites);
        });
    }
    isFull() {
        return Promise.resolve(false);
    }
    mapToProductItemSku(favorites) {
        return favorites.skus.map((sku) => ({ sku }));
    }
    parseOrganizationSlugNameToEnum(organization) {
        switch (organization.toLowerCase()) {
            case 'bot':
                return favorites_1.FavoritesServiceProductOrganization.Boticario;
            case 'eud':
                return favorites_1.FavoritesServiceProductOrganization.Eudora;
            case 'oui':
                return favorites_1.FavoritesServiceProductOrganization.Oui;
            case 'qdb':
                return favorites_1.FavoritesServiceProductOrganization.EuAmoMake;
            default:
                throw new Error(`Invalid organization: ${organization}`);
        }
    }
}
exports.FavoritesRepositoryApiImpl = FavoritesRepositoryApiImpl;
